import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDownTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KeyboardArrowDownTwoTone.js
// module id = 4315
// module chunks = 2